import React from 'react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';

const HelpContactScreen = ({navigation}: RouteNavigatorScreenProps<AppRoute.CONTACT_US>) => {
  const handleMenuItemPress = (item: any) => navigation.navigate(item.target);

  const menuItems = [{target: AppRoute.CONTACT_US_SUBMIT_TICKET, name: 'Submit a ticket'}];

  return (
    <ContentView testID="help-contact-screen">
      <FlatListMenu data={menuItems} onPressItem={handleMenuItemPress} />
    </ContentView>
  );
};

export default HelpContactScreen;
